import React from 'react';

const TimePickerSplit = ({ onChange, selectedTime = {} }) => {
  const hours = Array.from({ length: 24 }, (_, i) => i); // 0 to 23
  const minutes = Array.from({ length: 60 }, (_, i) => i); // 0 to 59

  const handleChange = (type, value) => {
    const parsedValue = value === '' ? null : parseInt(value);
    const newTime = {
      ...selectedTime,
      [type]: parsedValue,
    };
    onChange(newTime);
  };

  return (
    <div className="flex gap-2 items-center">
      <select
        value={selectedTime.hour ?? ''}
        onChange={(e) => handleChange('hour', e.target.value)}
        className="p-2 border rounded"
      >
        <option value="">HH</option>
        {hours
          .filter((h) => h !== 0) // remove 00 hour
          .map((h) => (
            <option key={h} value={h}>
              {h.toString().padStart(2, '0')}
            </option>
          ))}
      </select>

      <span>:</span>

      <select
        value={selectedTime.minute ?? ''}
        onChange={(e) => handleChange('minute', e.target.value)}
        className="p-2 border rounded"
      >
        <option value="">MM</option>
        {minutes.map((m) => (
          <option key={m} value={m}>
            {m.toString().padStart(2, '0')}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TimePickerSplit;
